import React from 'react';
import { useForm } from 'react-hook-form';

import BaseInput from 'components/Inputs/BaseInput';
import SolidButton from 'components/SolidButton';

import { ISpecialService } from 'utils/interfaces';
import { REQUIRED_RULE } from 'utils/constants';

export default function RangeModalContent({
  title,
  editData,
  onClose,
  onSubmit,
}: {
  title: string;
  editData?: ISpecialService;
  onClose: () => void;
  onSubmit: (data: any) => void;
}) {
  const {
    register,
    watch,
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<any>({
    defaultValues: editData || {
      user_type: 'person',
    },
  });

  const buildBaseInput = (
    label: string,
    type: React.HTMLInputTypeAttribute,
    name: string,
    rules: any,
    props: any
  ) => {
    return (
      <BaseInput
        label={label}
        type={type}
        name={name}
        register={register}
        control={control}
        watch={watch}
        errors={errors}
        rules={rules}
        {...props}
      />
    );
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="rounded-t-lg bg-primary-600 px-4 pb-4 sm:flex sm:items-start sm:p-6 sm:py-4">
        <div className="mt-3 text-center sm:mt-0 sm:text-left">
          <h3 className="text-lg font-medium leading-6 text-white" id="modal-headline">
            {title || 'Confirmar acción'}
          </h3>
        </div>
      </div>
      <div onSubmit={handleSubmit(onSubmit)} className="space-y-4 px-4 py-5 sm:p-6">
        {buildBaseInput('Número de documento', 'text', 'number', REQUIRED_RULE, {})}
        {buildBaseInput('Tipo de usuario', 'select', 'user_type', REQUIRED_RULE, {
          options: [
            { value: 'person', name: 'Persona Natural' },
            { value: 'company', name: 'Empresa' },
          ],
        })}
        {buildBaseInput('spCompra', 'number', 'sp_compra', REQUIRED_RULE, {})}
        {buildBaseInput('spVenta', 'number', 'sp_venta', REQUIRED_RULE, {})}
      </div>
      <div className="rounded-b-lg bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
        <SolidButton className="w-auto sm:ml-3" onClick={() => handleSubmit(onSubmit)}>
          {editData ? 'Guardar cambios' : 'Agregar'}
        </SolidButton>
        <button
          type="button"
          onClick={onClose}
          className="focus:ring-primary-500 mt-3 inline-flex w-full justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-base font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 sm:mt-0 sm:w-auto sm:text-sm"
        >
          Cancelar
        </button>
      </div>
    </form>
  );
}
